import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "user-detail-body" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "user-inp" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "usr-selector" }
const _hoisted_11 = { class: "user-row" }
const _hoisted_12 = ["checked", "disabled"]
const _hoisted_13 = ["checked", "disabled"]
const _hoisted_14 = { class: "usr-selector container" }
const _hoisted_15 = { class: "user-row" }
const _hoisted_16 = ["checked", "disabled"]
const _hoisted_17 = ["checked", "disabled"]
const _hoisted_18 = { class: "user-column" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "container user-rates" }
const _hoisted_22 = {
  key: 0,
  class: "accent dx-icon-warning"
}
const _hoisted_23 = {
  key: 0,
  class: "user-actions"
}
const _hoisted_24 = { class: "buttons" }
const _hoisted_25 = { class: "container" }
const _hoisted_26 = ["onUpdate:modelValue", "disabled", "onInput"]
const _hoisted_27 = {
  key: 0,
  class: "user-actions"
}
const _hoisted_28 = { class: "buttons" }
const _hoisted_29 = { class: "container" }
const _hoisted_30 = { class: "user-row" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "buttons" }
const _hoisted_33 = ["disabled"]

import { UserItem } from "@/services/entities/UserItem";
import { useAzureStore } from "@/stores/azure";
import { useSettingsStore } from "@/stores/setting";
import { computed, onMounted, reactive, watch, ref } from "vue";
import VueSelect from "vue-select";
import { getKey, debounce } from "@/common/util";
import { UserRateItem } from "@/services/entities/UserRateItem";
import DxButton from 'devextreme-vue/button';
import { useVfm } from "vue-final-modal";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import { useUserStore } from "@/stores/user";
import UserProjectsModal from "../modals/UserProjectsModal.vue";
import { showToastError } from "@/toastification";
import { formatMXDate } from "@/common/date";
import { RateItem } from "@/services/entities/RateItem";
import Popper from "vue3-popper";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDetail',
  props: {
    user: { Type: {} as UserItem, default: {} as UserItem },
},
  emits: ['create', 'update', "deleteUserRate", "search"],
  setup(__props, { emit: __emit }) {

const azureStore = useAzureStore();
const settingsStore = useSettingsStore();
const userStore = useUserStore();
const vfm = useVfm();
const confirmModalId = Symbol("confirmModalId");
const userProjectId = Symbol("userProjectId");

const updateClicked = ref(false);

const props = __props;

const isCreate = computed(() => {
    return !props.user.created;
});

watch(() => props.user.id, async (newUser, OldUser) => {
    state.edit = props.user.created == null;
    if (props.user.id) {
        await loadManager(props.user.id);
    }
});
const state = reactive({
    edit: props.user.created == null,
    deleteUserRateId: "",
    activeRates: [] as RateItem[],
    allRates: [] as RateItem[],
});

onMounted(async () => {
    await settingsStore.loadRates();
    state.activeRates = settingsStore.getRates.filter(r => !r.disabled);
    state.allRates = settingsStore.getRates;
});

function getRatesOptions(selectedRateId: string) {
  const selectedRate = state.allRates.find(r => r.id === selectedRateId);
  if (selectedRate && !state.activeRates.some(r => r.id === selectedRateId)) {
    return [...state.activeRates, selectedRate];
  }
  return state.activeRates;
}

function isRateDisabled(rate: UserRateItem) {
  return rate?.rate?.disabled;
}

const emit = __emit;

const handleSearch = debounce(async (query: string) => {
    if (query != "")
        await azureStore.searchUser(query);
}, 500);

function getActiveRates() {
    let allRates = settingsStore.getRates;
    return allRates.filter(r => !r.disabled);
}

async function deleteRate(rate: UserRateItem, index: number) {
    if (rate.id) {
        state.deleteUserRateId = rate.id;
        vfm.open(confirmModalId);
    }
    else {
        props.user.rates.splice(index);
    }
}

function checkInput(index: number) {
    let input = props.user.dailyCommitments[index].hours;
    if (input) {
        if (input > 24) {
            showToastError("Day does not have more than 24 hours");
            props.user.dailyCommitments[index].hours = 0;
        } else if (input < 0) {
            showToastError("Day value cannot be bellow zero");
            props.user.dailyCommitments[index].hours = 0;
        } else if (input % 0.5 != 0) {
            showToastError("Only half or full hours are allowed");
            props.user.dailyCommitments[index].hours = input - (input % 0.5);
        } else {
            props.user.dailyCommitments[index].hours = input;
        }
    } else {
        props.user.dailyCommitments[index].hours = input;
    }
}

async function deleteDailyCommitment(commitment: any, index: number) {
    if (commitment.id) {
        userStore.deleteDailyCommitment(commitment.id);
    }
    props.user.dailyCommitments.splice(index);
}   

function showProjects() {
    vfm.open(userProjectId);
}

async function selectedUser(option: any) {
    props.user.email = option.mail;
    props.user.id = option.id;
    props.user.firstName = option.givenName;
    props.user.lastName = option.surname;
    await loadManager(option.id);
}

async function loadManager(id: string) {
    await azureStore.loadUserManager(id);
    props.user.managerId = azureStore.getUserManager.id;
    props.user.managerEmail = azureStore.getUserManager.mail;
}

function addRate() {
    if (!props.user.rates) {
        props.user.rates = [];
    }
    const now = new Date();
    const year = now.getFullYear();
    const month =  now.getMonth();
    props.user.rates.push({ 
        userId: props.user.id,
        month: month, 
        year: year, 
        yearMonth: {year: year, month: month}} as UserRateItem);
}

function addDailyCommitment() {
    if (!props.user.dailyCommitments || props.user.dailyCommitments.length == 0) {
        props.user.dailyCommitments = [];
        let nextDate = new Date(props.user.startDate);
        props.user.dailyCommitments.push({
            yearMonth: { year: nextDate.getFullYear(), month: nextDate.getMonth() },
            year: nextDate.getFullYear(),
            month: nextDate.getMonth(),
            hours: 0,
        });
    }
    else {
        let index = props.user.dailyCommitments.length - 1;
        let lastTo = new Date();
        if (props.user.dailyCommitments[index]?.yearMonth) {
            lastTo = new Date(props.user.dailyCommitments[index].yearMonth.year, props.user.dailyCommitments[index].yearMonth.month, 1)
        }
        let nextDate = new Date(lastTo.getFullYear(), lastTo.getMonth(), 1);
        props.user.dailyCommitments.push({
            yearMonth: { year: nextDate.getFullYear(), month: nextDate.getMonth() },
            year: nextDate.getFullYear(),
            month: nextDate.getMonth(),
            hours: 0,
        });
    }
}

function processRates() {
    props.user.rates = props.user.rates?.filter(r => r.rateId);
}

function processDailyCommitment() {
    props.user.dailyCommitments = props.user.dailyCommitments?.filter(a => a.hours);
}

function createUser() {
    props.user.employeeId = props.user.employeeId ? String(props.user.employeeId) : null;
    processRates();
    processDailyCommitment();
    emit('create', props.user);
}

function updateUser() {
    updateClicked.value = true;
    props.user.employeeId = props.user.employeeId ? String(props.user.employeeId) : null;
    processDates();
    var dateCheck = checkStartEndDate()
    if (!dateCheck.result) {
        showToastError(dateCheck.message);
        updateClicked.value = false;
        return;
    }   
    processRates();
    processDailyCommitment();
    emit('update', props.user);
    state.edit = false;
    updateClicked.value = false;    
}

function processDates() {
    if (!props.user.isDeleted) {
        props.user.endDate == null;
    }
}

function checkStartEndDate(): {result: boolean, message: string } {
    if (!props.user.isDeleted)
        return {result: true, message: ""}
    else {
        if (props.user.startDate == null || undefined) {
            return {result: false, message: "Start Date need to be specified"};
        }
    }
    if (props.user.endDate == null || undefined)
        return { result: false, message: "End date need to be specified for Non Active user"};
    if (props.user.startDate >= props.user.endDate) 
        return { result: false, message: "End date need to be after the Start date"};
    return {result: true, message: "" };
}

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!isCreate.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "User detail"))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "Create user"))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _cache[23] || (_cache[23] = _createElementVNode("label", null, "Email", -1)),
            _createVNode(_unref(VueSelect), {
              label: "mail",
              options: _unref(azureStore).getGroupMembers,
              clearable: false,
              modelValue: props.user.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.user.email) = $event)),
              "onOption:selected": _cache[1] || (_cache[1] = (a) => selectedUser(a)),
              onSearch: _unref(handleSearch),
              disabled: !state.edit
            }, null, 8, ["options", "modelValue", "onSearch", "disabled"])
          ]),
          _createElementVNode("div", null, [
            _cache[24] || (_cache[24] = _createElementVNode("label", null, "Team leader", -1)),
            _createVNode(_unref(VueSelect), {
              label: "email",
              options: _unref(userStore).getTeamLeaders,
              clearable: false,
              modelValue: props.user.teamLeaderId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.user.teamLeaderId) = $event)),
              reduce: (item) => item.id,
              disabled: !state.edit
            }, null, 8, ["options", "modelValue", "reduce", "disabled"])
          ]),
          _createElementVNode("div", null, [
            _cache[25] || (_cache[25] = _createElementVNode("label", null, "Given name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "string",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((props.user.firstName) = $event)),
              disabled: !state.edit
            }, null, 8, _hoisted_6), [
              [_vModelText, props.user.firstName]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[26] || (_cache[26] = _createElementVNode("label", null, "Surname", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "string",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((props.user.lastName) = $event)),
              disabled: !state.edit
            }, null, 8, _hoisted_7), [
              [_vModelText, props.user.lastName]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[27] || (_cache[27] = _createElementVNode("label", null, "Employee ID", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "string",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((props.user.employeeId) = $event)),
              disabled: !state.edit
            }, null, 8, _hoisted_8), [
              [_vModelText, props.user.employeeId]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[28] || (_cache[28] = _createElementVNode("label", null, "Cost center", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "string",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((props.user.costCenter) = $event)),
              disabled: !state.edit
            }, null, 8, _hoisted_9), [
              [_vModelText, props.user.costCenter]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[29] || (_cache[29] = _createElementVNode("label", null, "Start date", -1)),
            _createVNode(_component_VueDatePicker, {
              clearable: false,
              teleport: true,
              "enable-time-picker": false,
              disabled: !state.edit,
              modelValue: props.user.startDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((props.user.startDate) = $event)),
              format: _unref(formatMXDate)
            }, null, 8, ["disabled", "modelValue", "format"])
          ]),
          _createElementVNode("div", null, [
            _cache[30] || (_cache[30] = _createElementVNode("label", null, "End date", -1)),
            _createVNode(_component_VueDatePicker, {
              clearable: false,
              teleport: true,
              "enable-time-picker": false,
              disabled: !(state.edit && props.user.isDeleted),
              modelValue: props.user.endDate,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((props.user.endDate) = $event)),
              format: _unref(formatMXDate)
            }, null, 8, ["disabled", "modelValue", "format"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[33] || (_cache[33] = _createElementVNode("span", null, "Active", -1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("input", {
              type: "radio",
              id: "r-yes",
              name: "active",
              checked: props.user.isDeleted != null && !props.user.isDeleted,
              onClick: _cache[9] || (_cache[9] = () => props.user.isDeleted = false),
              disabled: !state.edit
            }, null, 8, _hoisted_12),
            _cache[31] || (_cache[31] = _createElementVNode("label", { for: "r-yes" }, "Yes", -1)),
            _createElementVNode("input", {
              type: "radio",
              id: "r-no",
              name: "active",
              checked: props.user.isDeleted != null && props.user.isDeleted,
              onClick: _cache[10] || (_cache[10] = () => props.user.isDeleted = true),
              disabled: !state.edit
            }, null, 8, _hoisted_13),
            _cache[32] || (_cache[32] = _createElementVNode("label", { for: "r-no" }, "No", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[38] || (_cache[38] = _createElementVNode("h4", null, "Roles", -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("input", {
              type: "radio",
              id: "r-emp",
              name: "roles",
              checked: props.user.role != null && props.user.role == 1,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (props.user.role = 1)),
              disabled: !state.edit
            }, null, 8, _hoisted_16),
            _cache[36] || (_cache[36] = _createElementVNode("label", { for: "r-emp" }, "Employee", -1)),
            _createElementVNode("input", {
              type: "radio",
              id: "r-leader",
              name: "roles",
              checked: props.user.role != null && props.user.role == 2,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (props.user.role = 2)),
              disabled: !state.edit
            }, null, 8, _hoisted_17),
            _cache[37] || (_cache[37] = _createElementVNode("label", { for: "r-leader" }, "Team leader", -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "r-admin",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((props.user.isAdmin) = $event)),
                  disabled: !state.edit
                }, null, 8, _hoisted_19), [
                  [_vModelCheckbox, props.user.isAdmin]
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("label", { for: "r-admin" }, "Admin", -1))
              ]),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "r-report",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((props.user.isReport) = $event)),
                  disabled: !state.edit
                }, null, 8, _hoisted_20), [
                  [_vModelCheckbox, props.user.isReport]
                ]),
                _cache[35] || (_cache[35] = _createElementVNode("label", { for: "r-report" }, "Report", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[40] || (_cache[40] = _createElementVNode("h4", null, "Rates", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.user.rates, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "user-row",
              key: _unref(getKey)('us-rates', index)
            }, [
              _createVNode(_unref(Popper), {
                content: "This rate is not Active",
                class: "tooltip",
                hover: "",
                openDelay: "200",
                closeDelay: "100"
              }, {
                default: _withCtx(() => [
                  (item?.rate?.disabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(VueSelect), {
                clearable: false,
                appendToBody: true,
                options: getRatesOptions(item.rateId),
                label: "name",
                disabled: !state.edit,
                reduce: (item) => item.id,
                modelValue: item.rateId,
                "onUpdate:modelValue": ($event: any) => ((item.rateId) = $event)
              }, null, 8, ["options", "disabled", "reduce", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_VueDatePicker, {
                clearable: false,
                teleport: true,
                "enable-time-picker": false,
                disabled: !state.edit,
                "month-picker": "",
                modelValue: item.yearMonth,
                "onUpdate:modelValue": ($event: any) => ((item.yearMonth) = $event)
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
              (state.edit || isCreate.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_unref(DxButton), {
                      icon: "trash",
                      onClick: ($event: any) => (deleteRate(item, index))
                    }, null, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_24, [
            (state.edit)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (addRate()))
                }, [...(_cache[39] || (_cache[39] = [
                  _createElementVNode("b", null, "+", -1),
                  _createTextVNode("Add", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[42] || (_cache[42] = _createElementVNode("h4", null, "Daily commitment", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.user.dailyCommitments, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "user-row",
              key: _unref(getKey)('us-commitment', index)
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": ($event: any) => ((item.hours) = $event),
                disabled: !state.edit,
                onInput: ($event: any) => (checkInput(index))
              }, null, 40, _hoisted_26), [
                [_vModelText, item.hours]
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_VueDatePicker, {
                  clearable: false,
                  teleport: true,
                  "enable-time-picker": false,
                  "month-picker": "",
                  disabled: !state.edit,
                  placeholder: "From",
                  modelValue: item.yearMonth,
                  "onUpdate:modelValue": ($event: any) => ((item.yearMonth) = $event)
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
              ]),
              (state.edit || isCreate.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_unref(DxButton), {
                      icon: "trash",
                      onClick: ($event: any) => (deleteDailyCommitment(item, index))
                    }, null, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_28, [
            (state.edit)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (addDailyCommitment()))
                }, [...(_cache[41] || (_cache[41] = [
                  _createElementVNode("b", null, "+", -1),
                  _createTextVNode("Add", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _cache[43] || (_cache[43] = _createElementVNode("h4", null, "Overtime correction", -1)),
          _createElementVNode("div", _hoisted_30, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((props.user.overtimeFond) = $event)),
              disabled: !state.edit
            }, null, 8, _hoisted_31), [
              [_vModelText, props.user.overtimeFond]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          (props.user.created)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: showProjects
              }, "Show projects"))
            : _createCommentVNode("", true),
          (!props.user.created)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "accent",
                onClickOnce: _cache[18] || (_cache[18] = ($event: any) => (createUser()))
              }, "Create user", 32))
            : (!state.edit)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (state.edit = !state.edit))
                }, "Edit"))
              : (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  disabled: updateClicked.value,
                  class: "accent",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (updateUser()))
                }, "Save changes", 8, _hoisted_33))
        ])
      ])
    ]),
    _createVNode(ConfirmModal, {
      "modal-id": _unref(confirmModalId),
      text: "Do you really want to remove this rate? It might negativly affect reports and other functionality.",
      "confirm-text": "Delete user rate",
      onConfirm: _cache[21] || (_cache[21] = ($event: any) => {emit('deleteUserRate', state.deleteUserRateId); _unref(vfm).close(_unref(confirmModalId))}),
      onClose: _cache[22] || (_cache[22] = ($event: any) => (_unref(vfm).close(_unref(confirmModalId))))
    }, null, 8, ["modal-id"]),
    _createVNode(UserProjectsModal, {
      "modal-id": _unref(userProjectId),
      "user-id": props.user.id
    }, null, 8, ["modal-id", "user-id"])
  ], 64))
}
}

})